'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Skeleton } from '../../skeleton';

import styles from './Accordion.Skeleton.module.scss';

export type AccordionSkeletonProps = BaseComponentProps & {
  items: number;
};

function AccordionSkeleton({
  style,
  className,
  items,
}: AccordionSkeletonProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      {[...Array(items)].map((_, index) => (
        <div key={index} className={styles['row']}>
          <Skeleton className={styles['row__header']} />
          <div>
            <Skeleton className={styles['row__item']} />
          </div>
          <Skeleton className={styles['row__footer']} />
        </div>
      ))}
    </div>
  );
}

export { AccordionSkeleton };
